// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/groupPhoto.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

li {
  font-size: 1.25em;
}




code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.sectionPart {
  padding: 1.5em;
  font-size: 1.5em;
  background-color: white;
  margin-bottom: 5%;
}

.carousel {
  height: 500px;
  width: 80%;
}


#paypalform {
  float: right;
  position: relative;
  font-size: 10px !important;
  background-color: white;
  width: 10%;
  height: 10%;
  margin-right: 1em;
}

.logo{
  margin: 0%;
  margin-left: 40%;
  float:left;
}

@media only screen and (max-width: 500px) {
  #paypalform {
    float: left;
    font-size: 10px !important;
    width: 60%;
    margin-left: 30%;
  }
  .logo{
    margin-left: 20%;
  }
}

.welcomebox{
  padding-top: 1em !important;
  height: 30% !important;
  width: 100%;
  background-position: center;
  color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.buttonv1 {
  background-color: #800000;
  border-radius: 8px;
  color: white;
  width: 5%;
  height: 2em;
  padding: 3px;
}

.buttonv1:hover{
  background-color: #660000;
}

.contentleft {
  width: 40%;
  height: 25em;
  padding: 4%;
  float: left;
  z-index: 5;
  position: relative;
  margin-bottom: 1em;
}
.contentright {
  width: 50%;
  height: 25em;
  padding: 0;
  margin-right: 3em;
  float: right;
}

.content {
  margin-top: 2%;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  z-index: 1;

}
.contentfull {
  z-index: 1;
  margin-top: 2%;
  margin-left: 2%;
  margin-right: 0%;
  margin-bottom: 2%;

}

.audioplayer {
   position: fixed;
   margin-top: 5%;
   left: 0;
   bottom: 10%;
   width: 100%;
   background-color: #800000;
   color: white;
   text-align: center;
}


.playListDisplay {
  width: 100%;
  margin-bottom: 10%;
  overflow-y: scroll;

}
.playListDisplay ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.playListDisplay li {
  display: block;
  background-color: white;
}

.playListDisplay li:hover {
  display: block;
   width: 100%;
   background-color: #3d3d3d;
   color: white;
}



.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #800000;
   color: white;
   text-align: center;
}



.dropdown {
  color: white !important;
}
.navbar {
	   background-color: #800000 !important;
	   width: 100% !important;
}

.navbarx {
  color: white !important;
}

.navbarx a {

  color: white !important;
}

.navbarx:hover {
  background: #660000;
  border-radius: 4px;
}

.navbarxr {
  color: white !important;
  text-align: right;
}



.nav-link {
	color: black;
}

.nav-item {
	color: white !important;
}

.logincontainer{
  width: 50%;
}


.dropdown {
  color: white;
  background-color: #800000;
}

.dropdown a{
  color: white;
  background-color: #800000;
  font-size: 1.25em;

}
.dropdown li {
  color: white;
  background-color: #800000;
}
.dropdown a:hover {
  color: white;
  background-color: #660000;
}


.visitation ul{
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: #f1f1f1;
}

.visitation li a {
  display: block;
  color: #000;
  padding: 8px 16px;
  text-decoration: none;
}

/* Change the link color on hover */
.visitation li a:hover {
  background-color: #555;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;;;;AAKA;EACE;aACW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,0BAA0B;IAC1B,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,yDAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;;AAEZ;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;GACG,eAAe;GACf,cAAc;GACd,OAAO;GACP,WAAW;GACX,WAAW;GACX,yBAAyB;GACzB,YAAY;GACZ,kBAAkB;AACrB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;;AAEpB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;GACb,WAAW;GACX,yBAAyB;GACzB,YAAY;AACf;;;;AAIA;GACG,eAAe;GACf,OAAO;GACP,SAAS;GACT,WAAW;GACX,yBAAyB;GACzB,YAAY;GACZ,kBAAkB;AACrB;;;;AAIA;EACE,uBAAuB;AACzB;AACA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;;;AAIA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;;AAEnB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;;AAGA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":["\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nli {\n  font-size: 1.25em;\n}\n\n\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.sectionPart {\n  padding: 1.5em;\n  font-size: 1.5em;\n  background-color: white;\n  margin-bottom: 5%;\n}\n\n.carousel {\n  height: 500px;\n  width: 80%;\n}\n\n\n#paypalform {\n  float: right;\n  position: relative;\n  font-size: 10px !important;\n  background-color: white;\n  width: 10%;\n  height: 10%;\n  margin-right: 1em;\n}\n\n.logo{\n  margin: 0%;\n  margin-left: 40%;\n  float:left;\n}\n\n@media only screen and (max-width: 500px) {\n  #paypalform {\n    float: left;\n    font-size: 10px !important;\n    width: 60%;\n    margin-left: 30%;\n  }\n  .logo{\n    margin-left: 20%;\n  }\n}\n\n.welcomebox{\n  padding-top: 1em !important;\n  height: 30% !important;\n  width: 100%;\n  background-position: center;\n  color: white;\n  background-image: url(\"images/groupPhoto.png\");\n}\n\n.buttonv1 {\n  background-color: #800000;\n  border-radius: 8px;\n  color: white;\n  width: 5%;\n  height: 2em;\n  padding: 3px;\n}\n\n.buttonv1:hover{\n  background-color: #660000;\n}\n\n.contentleft {\n  width: 40%;\n  height: 25em;\n  padding: 4%;\n  float: left;\n  z-index: 5;\n  position: relative;\n  margin-bottom: 1em;\n}\n.contentright {\n  width: 50%;\n  height: 25em;\n  padding: 0;\n  margin-right: 3em;\n  float: right;\n}\n\n.content {\n  margin-top: 2%;\n  margin-left: 2%;\n  margin-right: 2%;\n  margin-bottom: 2%;\n  z-index: 1;\n\n}\n.contentfull {\n  z-index: 1;\n  margin-top: 2%;\n  margin-left: 2%;\n  margin-right: 0%;\n  margin-bottom: 2%;\n\n}\n\n.audioplayer {\n   position: fixed;\n   margin-top: 5%;\n   left: 0;\n   bottom: 10%;\n   width: 100%;\n   background-color: #800000;\n   color: white;\n   text-align: center;\n}\n\n\n.playListDisplay {\n  width: 100%;\n  margin-bottom: 10%;\n  overflow-y: scroll;\n\n}\n.playListDisplay ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.playListDisplay li {\n  display: block;\n  background-color: white;\n}\n\n.playListDisplay li:hover {\n  display: block;\n   width: 100%;\n   background-color: #3d3d3d;\n   color: white;\n}\n\n\n\n.footer {\n   position: fixed;\n   left: 0;\n   bottom: 0;\n   width: 100%;\n   background-color: #800000;\n   color: white;\n   text-align: center;\n}\n\n\n\n.dropdown {\n  color: white !important;\n}\n.navbar {\n\t   background-color: #800000 !important;\n\t   width: 100% !important;\n}\n\n.navbarx {\n  color: white !important;\n}\n\n.navbarx a {\n\n  color: white !important;\n}\n\n.navbarx:hover {\n  background: #660000;\n  border-radius: 4px;\n}\n\n.navbarxr {\n  color: white !important;\n  text-align: right;\n}\n\n\n\n.nav-link {\n\tcolor: black;\n}\n\n.nav-item {\n\tcolor: white !important;\n}\n\n.logincontainer{\n  width: 50%;\n}\n\n\n.dropdown {\n  color: white;\n  background-color: #800000;\n}\n\n.dropdown a{\n  color: white;\n  background-color: #800000;\n  font-size: 1.25em;\n\n}\n.dropdown li {\n  color: white;\n  background-color: #800000;\n}\n.dropdown a:hover {\n  color: white;\n  background-color: #660000;\n}\n\n\n.visitation ul{\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  width: 200px;\n  background-color: #f1f1f1;\n}\n\n.visitation li a {\n  display: block;\n  color: #000;\n  padding: 8px 16px;\n  text-decoration: none;\n}\n\n/* Change the link color on hover */\n.visitation li a:hover {\n  background-color: #555;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
